"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.463 4.644a7.5 7.5 0 0 1 4.335 2.598c1.121 1.367 1.803 3.094 1.49 4.66a.5.5 0 1 0 .98.196c.395-1.97-.47-3.995-1.697-5.49a8.5 8.5 0 1 0-.56 11.403.5.5 0 1 0-.708-.707 7.5 7.5 0 1 1-3.84-12.66"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.5 7a.5.5 0 0 1 1 0v4.434a.5.5 0 0 0 .243.429l2.014 1.208a.5.5 0 0 1-.514.858l-2.015-1.209a1.5 1.5 0 0 1-.728-1.286z"
  })]
}), 'Clock');
//# sourceMappingURL=index.js.map